import React, {Component} from 'react'
import {Link} from "react-router-dom"

class MainNav extends Component {
	render() {
		let navs=this.props.navs
		return (
			<div className={'mainNav'}>
				{
					navs.map((item,index)=>{
						if (index===navs.length-1){
							return <span key={index}><Link className={'a'} to={item.link}>{item.name}</Link></span>
						}else {
							return (
								<span key={index}><Link className={'a'} to={item.link}>{item.name}</Link>
							  <span> > </span></span>
							)
						}
					})
				}
			</div>
		)
	}
}

export default MainNav